import { render, staticRenderFns } from "./RelatorioCategoriaProduto.vue?vue&type=template&id=eaa724d0"
import script from "./RelatorioCategoriaProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioCategoriaProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports